var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.09091C9 1.38385 10.3431 0 12 0H15C16.6569 0 18 1.38385 18 3.09091V4.63636H21V7.72727C21 8.5808 20.3284 9.27273 19.5 9.27273H7.5C6.67157 9.27273 6 8.5808 6 7.72727V4.63636H9V3.09091ZM13.5 3.09091C12.6716 3.09091 12 3.78283 12 4.63636C12 5.48989 12.6716 6.18182 13.5 6.18182C14.3284 6.18182 15 5.48989 15 4.63636C15 3.78283 14.3284 3.09091 13.5 3.09091Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6.18182H0V34H27V6.18182H22.5V7.72727C22.5 9.43433 21.1569 10.8182 19.5 10.8182H7.5C5.84315 10.8182 4.5 9.43433 4.5 7.72727V6.18182ZM3 13.9091V17H6V13.9091H3ZM24 13.9091H9V17H24V13.9091ZM3 20.0909V23.1818H6V20.0909H3ZM24 20.0909H9V23.1818H24V20.0909ZM3 26.2727V29.3636H6V26.2727H3ZM24 26.2727H9V29.3636H24V26.2727Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.22b33493a8165a15bff9e5d44eff4c47.svg";
export { ForwardRef as ReactComponent };